export default "__VITE_ASSET__tQC2dU0u__"